function extractOptionsFromProps(props, exclude) {
  props = {
    ...props
  };

  // keep only defined props
  Object.keys(props).forEach(prop => {
    if (props[prop] === undefined || exclude.includes(prop)) delete props[prop];
  });
  return props;
}

export { extractOptionsFromProps };
